import { render, staticRenderFns } from "./upComDetail.vue?vue&type=template&id=665b935c&"
import script from "./upComDetail.vue?vue&type=script&lang=js&"
export * from "./upComDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports